import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const ScrollContainer = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`;

export const Container = styled.div<{ $itemWidth: number }>`
  height: 100%;
  width: 100%;

  .fc {
    ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};

    color: ${({ theme }) => theme.palette.text.secondary};
  }

  .fc table {
    border-width: 0;
  }

  .fc-scrollgrid-section.fc-scrollgrid-section-body:first-child {
    background: ${({ theme }) => theme.palette.background.default};
  }

  .fc .fc-scrollgrid-section-header {
    display: none;
  }

  .fc .fc-scrollgrid-section-sticky th {
    background: ${({ theme }) => theme.palette.background.default};
  }

  .fc .fc-daygrid-body .fc-timegrid-axis {
    background: ${({ theme }) => theme.palette.background.default};
  }

  .fc-timegrid-slot-label {
    width: 6rem;
    background: ${({ theme }) => theme.palette.background.default};
  }

  .fc-timegrid-slot.fc-timegrid-slot-lane {
    position: relative;

    &:hover::before {
      content: '';
      position: absolute;
      inset: 0;
      pointer-events: none;
    }
  }

  .fc .fc-col-header-cell-cushion {
    padding: ${({ theme }) => theme.spacing(2)};
  }

  .fc-header-toolbar {
    display: none;
  }

  .fc-timegrid-divider {
    display: none;
  }

  .fc-timegrid-col,
  .fc-timegrid-slot {
    border-color: ${({ theme }) => theme.palette.divider};
  }

  .fc-timegrid-slot {
    border-color: ${({ theme }) => theme.palette.divider};
  }

  .fc-more-popover {
    visibility: hidden;
    height: 0;
    width: 0;
    overflow: hidden;
  }

  .fc-timegrid-now-indicator-arrow {
    display: none;
  }

  .fc-daygrid-day.fc-day-today,
  .fc-timegrid-col.fc-day-today {
    background: inherit;
  }

  .fc-timegrid-event .fc-event-main {
    padding: 0;
  }

  .fc-day {
    border-color: ${({ theme }) => theme.palette.divider};
  }

  .fc-col-header-cell {
    border-color: transparent;
  }

  .fc-scrollgrid-section td,
  .fc-scrollgrid-section th {
    border-color: ${({ theme }) => theme.palette.divider};
  }

  .fc-view .fc-scrollgrid .fc-scrollgrid-section:last-child td {
    border-bottom-color: transparent;
  }

  .fc-scrollgrid-section .fc-timegrid-slot-minor {
    border-top-color: transparent;
  }

  .fc .fc-highlight {
    background: ${({ theme }) =>
      theme.palette.primaryExtended.opacityBackgroundBackground};
  }

  .fc-event {
    margin: ${({ theme }) => `0 ${theme.spacing(0.5)}`};
    padding: 0;

    border: none;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
  }

  .fc-event.fc-event-draggable {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    padding: ${({ theme }) => `0 ${theme.spacing(0.5)}`};
  }
`;
